/*
 * @Author: your name
 * @Date: 2022-03-01 11:06:55
 * @LastEditTime: 2022-05-26 17:38:54
 * @LastEditors: liuwujiang@easyretailpro.com liuwujiang@easyretailpro.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\store\modules\user.js
 */
import api from '@/api/api-hub'
import commonService from '@/utils/common-service'
import watermark from '@/plugins/watermark'

export default { 
    namespaced: true,
    state: {
        userInfo: null,
    },
    mutations: {
        // 设置用户信息-个人资料
        SET_USER_INFO(state, payload) {
            if(payload) {
                state.userInfo = payload
            }
        },
        // 设置水印（根据当前登录用户）
        SET_LOGIN_USER_WATERMARK(state, userInfo) {
            if(userInfo) {
                let phoneSuffix = commonService.getPhoneSuffix(userInfo.phone)
                let txt = `PepsiCo-${userInfo.realName}-${phoneSuffix}`
                watermark.create(txt)
            }
        }
    },
    actions: {
        SetUserInfo(context, payload) {
            context.commit('SET_USER_INFO', payload)
            context.commit('SET_LOGIN_USER_WATERMARK', payload)
        },
        // 获取当前登录人信息
        async getUserInfo (context) {
            await api.userClient.info().then(res=> {
                if(res) {
                    context.commit('SET_USER_INFO', res)
                    context.commit('SET_LOGIN_USER_WATERMARK', res)
                }
            })
        },
    },
    getters: {

    },
};